import { latLng } from 'leaflet'
import React, { useState, useEffect } from 'react'
import ContentBox from '../components/ContentBox'
import Header from 'components/home/Header';
import ParametrosApi from 'services/robinhood/ParametrosApi';

export default function Documents() {

  const [documentosUrl, setDocumentosUrl] = useState(null);

  useEffect(() => {

    document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
    new ParametrosApi().all().then(response => {
      response.map(parametro => {
        if (parametro.id == new ParametrosApi().documentos_url) {
          setDocumentosUrl(`https://drive.google.com/embeddedfolderview?id=${parametro.valor}#`);
        }
      });
    });

  }, []);

  return (
    <>

      <Header>
        <h5 style={{ marginLeft: '20px', marginBottom: '-60px' }}> <i className='zmdi zmdi-file-text'></i> DOCUMENTOS  REFERENTES A LEI ROBIN HOOD <small className='text-muted'>  </small>  </h5>
      </Header>

      <ContentBox>
        <p style={{ fontWeight: 'bold', fontSize: '14px' }}> DOCUMENTOS PÚBLICOS <small> </small> </p>
        <hr />
        <p>
          Relação de documentos públicos disponibilizados pela equipe técnica da Lei Robin Hood.
          {/* <br />Aqui você encontrará arquivos refenrentes a leis, portarias, decretos, normativas e resoluções. */}
        </p>
      </ContentBox>

      <ContentBox>
        <div className="row clearfix">
          <div className="col-md-12">
            <div className="card">
              {/* <div className="header">
              </div> */}
              <div className="body">
                <div className='row'>
                  <iframe key={Math.random()} src={documentosUrl + 'list'} style={{ width: '100%', minHeight: '450px', border: '0', marginTop: '-20px', overflowX: 'hidden', overflowY: 'scroll' }}></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentBox>
      <div className='m-b-100'></div>
    </>
  )
}
